<template>
  <div class="toupWrap">
    <div class="topNavBox">
      <div class="topbox clearfix border">
        <a href="javaScript:" class="fl back" @click="seeBack">
          <img src="~img/back@2x.png" alt="" />
        </a>
        <p class="fl">充值</p>
      </div>
    </div>
    <div class="consumeList clearfix">
      <a
        href="javaScript:"
        v-for="(item, index) in payList"
        :key="item.money"
        :class="{ fl: true, active: chooseIndex == index }"
        @click="chooseActive(item.money, index)"
      >
        <p>
          <span class="font">￥</span><span class="num">{{ item.money }}</span>
        </p>
        <p class="yuanbi">{{ item.yuanBi }}源币</p>
      </a>
    </div>
    <div class="account-input">
      <input
        class="myAccount"
        v-model="moneyValue"
        @keyup="custom($event)"
        @focus="getFocus"
        type="text"
        placeholder="请输入要充值的额度，数字格式，最低1元"
      />
    </div>
    <ul class="centenList">
      <li class="clearfix" @click="chooseType(1)">
        <a class="clearfix" href="javaScript:">
          <img class="fl item" src="~img/account/wx1@2x.png" alt="" />
          <p class="fl">微信</p>

          <div :class="{ active: type == 1, choose: true, fr: true }">
            <img src="~img/account/Shape@2x.png" alt="" />
          </div>
        </a>
      </li>
      <li class="clearfix" @click="chooseType(2)">
        <a class="clearfix" href="javaScript:">
          <img class="fl item" src="~img/account/zfb@2x.png" alt="" />
          <p class="fl">支付宝</p>
          <div :class="{ active: type == 2, choose: true, fr: true }">
            <img src="~img/account/Shape@2x.png" alt="" />
          </div>
        </a>
      </li>
    </ul>
    <button class="payBtn" @click="pay">立即充值：{{ allNum }}元</button>
    <div class="payhint">
      <p>
        1.人民币：源币兑换比例为：1元=100源币，源币属于虚拟商品，一经购买不得退换；
      </p>
      <p>2.充值获得源币仅限当前网站内使用；</p>
      <p>3.工作时间：周一到周日9:00-22:00；</p>
      <p>
        4.若充值后账户余额长时间无变化，请记录您的用户ID后联系客服
        客服QQ：1655338768，微信：zhangwencps
      </p>
    </div>
    <div
      class="isPaySuccess"
      v-if="
        isShow == 'true' && ($route.query.topUpId || $route.query.out_trade_no)
      "
    >
      <div class="successhint">
        <div class="bg">
          <div>提示</div>
        </div>
        <p class="hint">请确认微信支付是否已完成</p>
        <div @click="payOk" class="success button">已完成支付</div>
        <div @click="payError" class="error button">支付遇到问题，重新支付</div>
      </div>
    </div>
  </div>
</template>

<script>
import { payMoneyList, payMoney, zfMoney, payisSuccess } from "apiurl/pay";
export default {
  data() {
    return {
      payList: [],
      chooseIndex: 1,
      chooseMoney: 30,
      type: 1,
      moneyValue: null,
      allNum: 30,
      orderNo: "",
      isShow: localStorage.getItem("payShow") || "true"
    };
  },
  created() {
    if (this.$route.query.redirect) {
      localStorage.setItem("backurl", this.$route.query.redirect);
    }
    console.log("tag", localStorage.getItem("backurl"));
    this.$nextTick(() => {
      this.getGrage();
    });
  },
  methods: {
    seeBack() {
      if (localStorage.getItem("backurl")) {
        this.$router.push(localStorage.getItem("backurl"));
        localStorage.removeItem("backurl");
      } else {
        this.$router.push("/center?back=home");
      }
    },
    payError() {
      this.isShow = false;
      localStorage.setItem("payShow", false);
    },
    payOk() {
      payisSuccess({
        topUpId: this.$route.query.topUpId || this.$route.query.out_trade_no
      }).then(res => {
        if (res.success) {
          this.isShow = false;
          localStorage.setItem("payShow", false);
          if (localStorage.getItem("backurl")) {
            this.$router.push(localStorage.getItem("backurl"));
            localStorage.removeItem("backurl");
          } else {
            this.$router.push("/center?back=home");
          }
        } else {
          this.isShow = false;
          localStorage.setItem("payShow", false);
        }
      });
    },
    // 获取列表
    getGrage() {
      payMoneyList().then(res => {
        if (res.success) {
          this.payList = res.data.normal.gradeList;
        }
      });
    },
    chooseType(type) {
      this.type = type;
    },
    // 选择钱数
    chooseActive(money, index) {
      this.chooseIndex = index;
      this.chooseMoney = money;
      this.allNum = money;
      this.moneyValue = null;
    },
    custom() {
      if (this.moneyValue != "") {
        let flag = new RegExp("^[1-9]([0-9])*$").test(this.moneyValue);
        if (!flag) {
          this.moneyValue = null;
          this.allNum = 0;
          this.Toast({
            message: "请输入整数",
            duration: 2000,
            position: "top"
          });
        } else if (this.moneyValue > 1000) {
          this.moneyValue = null;
          this.allNum = 0;
          this.Toast({
            message: "最高充值1000元",
            duration: 2000,
            position: "top"
          });
        } else {
          this.allNum = this.moneyValue;
        }
      } else {
        this.allNum = 0;
      }
    },
    getFocus() {
      this.chooseIndex = 5;
    },
    // 充值
    pay() {
      if (this.type == 1) {
        payMoney({ amount: this.allNum * 100 }).then(res => {
          localStorage.setItem("payShow", true);
          this.orderNo = res.data.orderNo;
          window.location.href = `${res.data.payUrl}`;
        });
      } else {
        zfMoney({ amount: this.allNum * 100 }).then(res => {
          if (res.success) {
            let form = res.data.orderInfo;
            this.orderNo = res.data.topUpId;
            this.$router.push({
              path: "/alipay",
              query: { htmls: form }
            });
          }
        });
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
@import '~@/styles/cominxin.styl'
.toupWrap
    width 100vw
    height 100vh
    background:rgba(249,249,249,1);
.consumeList
    margin 27px 24px 0
    a
        width:336px;
        height:128px;
        display block
        background:rgba(255,255,255,1);
        border-radius:5px;
        border:1px solid rgba(218,218,218,1);
        box-sizing border-box
        padding 18px 0 0 17px
        margin-bottom 28px
        &.active
            background:rgba(203,227,255,0.18);
            border none
            box-shadow:0px 0px 10px 0px rgba(0,131,254,1);
        &:nth-child(2n)
            margin-left 28px
        .font
            font-size:30px;
            font-weight:600;
        .num
            font-size 42px
            font-family:Impact;
        .yuanbi
            margin-top 3px
            font-size:20px;
            color:rgba(85,85,85,1);
.account-input
    margin 0 26px 19px
    .myAccount
        display block
        width calc(100% - 25px)
        height 70px
        padding-left 25px
        placeMain(#999999, 24px, 0px)
.centenList
    padding 10px 23px 0 43px
    background #fff
    border:1px solid rgba(238,238,238,1);
    li
        padding 27px 0
        &:nth-child(1)
            // border-bottom 2px solid #eee
        .item
            width 38px
            height 38px
        a
            img
                width 14px
                &.fr
                    margin-top 7px
        button
            width 87px
            height 45px
            background rgba(92, 162, 245, 1)
            border-radius 23px
            color #fff
        p
            color #333333
            line-height 42px
            font-size 30px
            margin-left 21px
            span
                color #999999
                display inline-block
                margin-left 5px
                font-size 24px
        .choose
            width:28px;
            height:28px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(151,151,151,1);
            border-radius 50%
            text-align center
            line-height 28px
            &.active
                width:32px;
                height:32px;
                background:linear-gradient(180deg,rgba(126,223,255,1) 0%,rgba(73,202,255,1) 100%);
                box-shadow:0px 1px 3px 0px rgba(108,216,255,1);
                border none
                line-height 32px
.payBtn
    width:465px;
    height:70px;
    background:linear-gradient(135deg,rgba(122,209,255,1) 0%,rgba(29,133,241,1) 100%);
    box-shadow:0px 1px 20px 0px rgba(118,206,254,1);
    border-radius:35px;
    margin 36px auto 36px
    display block
    font-size:32px;
    color #fff
.payhint
    padding 0px 22px 11px 28px
    font-size:22px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height 40px
.isPaySuccess
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,0.48);
    position fixed
    top 0
    left 0
    .successhint
        width:550px;
        height:364px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 8px 0px rgba(0,0,0,0.24);
        border-radius:22px;
        position absolute
        top 0
        left 0
        right 0
        bottom 0
        margin auto
        .bg
            width:550px;
            height:99px;
            text-align center
            padding-top 18px
            font-size:36px;
            font-weight:500;
            color:rgba(85,85,85,1);
            border-radius:22px 22px 0 0;
            background url("../../../static/account/tankuangbg@2x.png") 0 0
            background-size cover
        .hint
            font-size:28px;
            color #555555
            text-align center
            line-height 44px
        .button
            width 100%
            background #fff
            color #555
            padding 25px 0
            text-align center
            font-size 30px
            &.success
                border-bottom 1px solid #999
                color #2189F2
                margin-top 15px
            &.error
                border-radius:22px;
</style>
